import * as React from "react";

import { IControlError, IControlSchema } from "../../../core/Controls";

import {buildUrl, Component, goToAnchor, I18NString} from "../../helpers/Utils";
import { IDispatcher } from "../../helpers/Dispatcher";
import Field from "../components/Field";
import ActionButton from "./ActionButton";
import { Alert } from "react-bootstrap";
import {ApiResponse, colorType, detailObject, MessageObject} from "./interfaces";
import ActionStrategy from "./ActionStrategy";
import ActionRefreshFormStrategy from "./ActionStrategy/ActionRefreshFormStrategy";
import ActionRefreshAndScrollStrategy from "./ActionStrategy/ActionRefreshAndScrollStrategy";
import ActionScrollToFieldStrategy from "./ActionStrategy/ActionScrollToFieldStrategy";
import ActionShowDetailModal from "./ActionStrategy/ActionShowDetailModal";

export interface ButtonsSetItems {
    "label": I18NString,
    "color": colorType,
    "handler": string
    "error": string
}

interface ButtonSetSchema extends IControlSchema {
    value?: any;
    buttons: ButtonsSetItems[];
    lines: string;
}

interface ButtonSetProps {
    schema: ButtonSetSchema;
    api: any;
    dispatcher?: IDispatcher;
    error: IControlError | undefined;
    visited: boolean;
    opts: any;
}

interface ButtonSetState {
    loading: boolean;
    message: MessageObject | null;
}

/**
 * Компонент с набором кнопок, которые умеют обновлять форму, скроллить до элемента итд
 * TODO Все экшены, действия надо привести к паттерну Strategy чтоб удобно было расширять функционал кнопок
 */
class ButtonSet extends Component<ButtonSetProps, ButtonSetState> {
    constructor(props) {
        super(props);

        this.replaceVariableInUrlString = this.replaceVariableInUrlString.bind(this);
        this.setLoading = this.setLoading.bind(this);
        this.setStrategyAndExecute = this.setStrategyAndExecute.bind(this);
        this.setMessage = this.setMessage.bind(this);

        this.state = {
            loading: false,
            message: null,
        }
    }
    setMessage(message: MessageObject): void {
        this.setState({message});
    }
    /**
     * Превращает строку типа /url/[request_id] в /url/12
     * @param handler
     */
    replaceVariableInUrlString(handler: string): string {
        const {
            api: {
                options
            }
        } = this.props;
        return buildUrl(handler, options);
    }
    /**
     * Управляет loader у всех кнопок
     * @param value
     */
    setLoading(value: boolean): void {
        this.setState({loading: value});
    }

    /**
     * Принимает объект, на основе которого определяет нужную стратегию (сделано в целях расширения функционала)
     * @param object
     */
    setStrategyAndExecute(object: ApiResponse) {
        const {
            opts: {
                formActions: {
                    actionRefreshForm,
                    actionScrollToField,
                    actionDetailNotify
                }
            }
        } = this.props;

        const strategySelector = new ActionStrategy([
            new ActionRefreshFormStrategy(actionRefreshForm),
            new ActionRefreshAndScrollStrategy(actionScrollToField),
            new ActionScrollToFieldStrategy(actionScrollToField),
            new ActionShowDetailModal(actionDetailNotify)
        ]);
        const strategy = strategySelector.selectStrategy(object);
        strategy.execute();
    }

    render() {
        const {
            loading,
            message
        } = this.state;

        return <Field {...this.props.schema}>
            <div className="groups__item" style={{display: 'flex', gap: 15}}>
                {
                    this.props.schema.buttons.map((item) => (
                        <ActionButton
                            loading={loading}
                            setLoading={this.setLoading}
                            setMessage={this.setMessage}
                            setStrategyAndExecute={this.setStrategyAndExecute}
                            label={item.label}
                            color={item.color}
                            handler={this.replaceVariableInUrlString(item.handler)}
                            error={item.error}
                        />
                    ))
                }
            </div>
            {
                // @ts-ignore
                message ? <Alert bsStyle={ message.bsStyle }>
                    { message.text }
                </Alert> : null
            }
        </Field>;
    }
}

export function createButtonSet(
    schema: IControlSchema,
    api: any,
    dispatcher: IDispatcher = null,
    error: IControlError | undefined,
    visited: boolean,
    opts: any,
): React.ReactElement<any> {
    return (
        <ButtonSet
            schema={schema as ButtonSetSchema}
            api={api}
            error={error}
            visited={visited}
            dispatcher={dispatcher}
            opts={opts}
        />
    );
}
